import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';

export const StyledSection = styled(Box)`
  position: relative;
`;

export const StyledAppBody = styled(Box)`
  width: 100%;
  position: relative;
  height: 450px;
  ${themeMediaQuery('below_sm')} {
    height: 400px;
  }
`;

export const AppTopWave = styled(CloudImage)`
  width: 110%;
  object-fit: cover;
  margin-bottom: -7px;
  min-height: 70px;
  ${themeMediaQuery('below_sm')} {
    min-height: auto;
  }
  ${themeMediaQuery('sm')} {
    min-height: 70px;
  }
  ${themeMediaQuery('md')} {
    min-height: 100px;
  }
  ${themeMediaQuery('xl')} {
    min-height: 150px;
  }
`;

export const LeftSectionTextPairing = styled(TextPairing)`
  padding-top: ${themeSpace(11)};
  .text-pairing-title {
    max-width: 220px;
  }
  .text-pairing-body {
    max-width: 310px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 100%;
    }
  }
`;

export const BlueThread1 = styled(CloudImage)`
  position: absolute;
  top: 15%;
  width: 35%;
`;

export const BlueThread2 = styled(CloudImage)`
  position: absolute;
  bottom: 5%;
  right: 0;
  width: 30%;
  ${themeMediaQuery('xl')} {
    width: 35%;
    bottom: -50px;
  }
  ${themeMediaQuery('below_sm')} {
    bottom: 11%;
  }
`;

export const StyledLogoWrapper = styled(Flex)`
  min-width: 140vw;
  overflow-x: scroll;
`;

export const StyledLogo = styled(CloudImage)`
  object-fit: contain;
  height: 60px;
  max-width: 100px;
  ${themeMediaQuery('below_sm')} {
    height: 50px;
    max-width: 80px;
  }
  ${themeMediaQuery('xl')} {
    height: 100px;
    max-width: 150px;
  }
`;

export const LogosWrapper = styled(Flex)`
  height: 200px;
  ${themeMediaQuery('below_sm')} {
    height: 150px;
  }
`;

export const LogosAnimation = styled(Flex)`
  position: absolute;
  height: 100%;
  will-change: transform;
`;

export const LogoBox = styled(Box)`
  height: max-content;
  width: max-content;
`;
